<template>
    <div class="tutordetail_home">

        <div class="td1">
            <div class="td1_cont">
                <div class="td1_left">
                    <div class="td1_line1">
                        <span>{{ tutorsData.category | tutorTitle }}</span>
                        <span id="adSpan">{{ tutorsData.school | adSchool }}</span>
                    </div>
                    <div class="td1_line2">
                        {{ tutorName }}
                    </div>
                    <div class="td_line3_box">
                        <div class="td_line3">
                            <div>所学专业：</div>
                            <p>{{ tutorsData.major }}</p>
                        </div>
                        <div class="td_line3">
                            <div>毕业院校：</div>
                            <p>{{ tutorsData.school | allSchool }} </p>
                        </div>
                    </div>
                    <div class="td1_btn_box">

                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <button>
                                <img src="../img/Group 768.png" alt="">
                                <p>在线提问</p>
                            </button>
                        </a>
                        <button @click="coverInp()">
                            <img src="../img/icon4.png" alt="">
                            <p>预约试听课</p>
                        </button>
                    </div>
                </div>
                <div class="td1_right_box">
                    <div class="td1_right_lan">
                        <div class="td1_right_lan_cont">
                            <div class="td1_right_lan_title1">
                                <p class="td1_right_lan_title ">培训学生</p>
                                <p><span>{{ tutorsData.student_num }}</span>人</p>
                            </div>
                            <div class="td1_right_lan_title2">
                                <p class="td1_right_lan_title ">申请成功率</p>
                                <p><span>{{ tutorsData.success_rate | rateFilter }}</span>%</p>
                            </div>
                        </div>
                    </div>
                    <div class="td1_right" @mouseleave="logoTright" @mouseenter="logoTleft">

                        <img :src="'https://public.rossoarts.com/static/uploads/teacher/' + tutorsData.avatar" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="td2">
            <div class="section_title">
                <p class="section_cn">导师简介</p>
                <p class="section_en">TUTOR INTRO</p>
            </div>
            <div class="td2_cont">
                <div class="td2_left_cont">{{ tutorsData.honor }}</div>
            </div>
        </div>
        <div class="td3">
            <div class="section_title">
                <p class="section_cn">录取案例</p>
                <p class="section_en">OFFER CASES</p>
            </div>
            <div class="td3_cont">
                <!-- <div class="td3_item"  v-for="(item,index) in luSchool" @click="jopSchoolDetail(item.id,item.cname)">
                    <img :src="'https://public.rossoarts.com/static/uploads/'+item.logo" alt="">
                    <div class="td3_hid">
                        <p>{{ item.cname }}</p>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="td4">
            <div class="section_title">
                <p class="section_cn">iTUTOR导师专访</p>
                <p class="section_en">iTUTOR INTERVIEW</p>
            </div>
            <div class="td4_cont">
                <div class="td4_item" v-for="(item, index) in artsTutor" @click="jopNews(item.id)">
                    <div class="t5_kuang">
                        <div class="t5_icon t5_icon1">
                            <div></div>
                        </div>
                        <div class="t5_icon t5_icon2">
                            <div></div>
                        </div>
                        <div class="t5_icon t5_icon3">
                            <div class="t5_icon3_1"></div>
                            <div class="t5_icon3_2"></div>

                        </div>
                    </div>
                    <img :src="'https://public.rossoarts.com/static/uploads/article/' + item.list_img" alt="">
                    <div class="t5_bottom">
                        {{ item.title }}
                    </div>
                </div>
            </div>
            <div class="td4_bottom" @click="jopNew" style="cursor: pointer;">
                <img src="../img/院校搜索/Group 569.png" alt="">
                <p>更多资讯</p>
            </div>
        </div>
        <div class="tutors6">
            <div class="section_title">
                <p class="section_cn">热门回答</p>
                <p class="section_en">POPULAR Q&A</p>
            </div>
            <div class="t6_cont">
                <img src="../img/Group 249.png" alt="" class="t6_left">
                <div class="t6_right">
                    <div v-for="(item, index) in qaData" class="t6_item" @click="t6Show(index)">
                        <div class="t6_item_show">
                            <div>Q：{{ item.question }}</div>
                            <img src="../img/师资/Group 333.png" alt="" class="t6_imgQ">
                        </div>

                        <div class="grid">
                            <div class="t6_item_hid">
                                <div style="margin-top: 20px;">A：{{ item.answer }}</div>
                                <img src="../img/师资/Group 334.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="t6_page">

                        <el-pagination layout="prev, pager, next" :total="qaTotal" @current-change="handelPage">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import "@/assets/css/tutorsdetail.css"
import axios from "axios"
export default {
    data() {
        return {
            tutorsData: [],
            tutorName: "",
            studentNum: "",
            studentRate: '',
            artsTutor: [],
            qaData: [],
            qaTotal: 0,
            qaPage: 1,
            flag: false,
            luSchool:[],
        }
    },


    filters: {
        adSchool(val) {

            if (val) {
                return val.split(',')[1]
            }
        },
        allSchool(val) {

            if (val) {
                return val.split(',')[0]
            }

        },
        tutorTitle(val) {
            if (val) {
                return val == 2 ? "海外导师" : "海归导师"
            }
        },
        rateFilter(val) {
            // console.log(val);
            if (val) {

                return val.split("%")[0]
            }
        }

    },
    created() {
        this.getTeacherDetail(this.$route.params.id.split(".")[0])
        // console.log(this.$route.params.id.split(".")[0]);
        this.getArtsNew(),
            this.getQa()
    },
    methods: {
        jopSchoolDetail(val,val2){
            this.$router.push({
              
              path:  `/schools/${val}.html?cname=${val2}`,
            
          })
        },
        coverInp() {
            var coverBlack2 = document.getElementById("coverBlack2")
            coverBlack2.style.display = "block"

        },
        jopNew() {
            this.$router.push("/news.html")
        },
        jopNews(val) {
            this.$router.push(`/news/${val}.html`)
        },
        t6Show(val) {
            var t6_item = document.getElementsByClassName("t6_item")
            var grid = document.getElementsByClassName("grid")
            var t6_item_show = document.getElementsByClassName("t6_item_show")
            var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag
            // console.log(grid[val].style.gridTemplateRows,val);
            if (grid[val].style.gridTemplateRows == "1fr") {
                // 不出
                grid[val].style.gridTemplateRows = "0fr";
                t6_item_show[val].style.backgroundColor = "#5f9df7"
                t6_item_show[val].style.border = "none"
                t6_item_show[val].style.margin = "0px"
                t6_imgQ[val].style.visibility = "visible"
            } else {
                // 出
                grid[val].style.gridTemplateRows = "1fr";
                t6_item_show[val].style.backgroundColor = "#FB6333"
                t6_item_show[val].style.border = "2px solid #000"
                t6_item_show[val].style.margin = "-2px -2px 0 -2px"
                t6_imgQ[val].style.visibility = "hidden"

            }
        },
        handelPage(val) {
            // console.log(val);
            this.qaPage = val
            this.getQa()

            var t6_item = document.getElementsByClassName("t6_item")
            var grid = document.getElementsByClassName("grid")
            var t6_item_show = document.getElementsByClassName("t6_item_show")
            var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag

            for (var i = 0; i < t6_item.length; i++) {
                grid[i].style.gridTemplateRows = "0fr";
                t6_item_show[i].style.backgroundColor = "#5f9df7"
                t6_item_show[i].style.border = "none"
                t6_item_show[i].style.margin = "0px"
                t6_imgQ[i].style.visibility = "visible"
            }

        },
        getQa() {
            axios.get(`https://public.rossoarts.com/api/v1/getQa?limit=5&page=${this.qaPage}`).then((data) => {
                // console.log(data.data.data);
                this.qaData = data.data.data
                this.qaTotal = data.data.total
                // this.artsTutor = this.arrGroup(data.data.data.data, 4)
            })
        },
        getArtsNew() {
            axios.get("https://public.rossoarts.com/api/v1/getArtsNews?category=30&limit=4&page=1").then((data) => {
                // console.log(data.data.data.data, "导师分享");
                this.artsTutor = data.data.data.data

            })
        },
        logoTleft() {
            var td1_right = document.getElementsByClassName("td1_right")

            if (this.studentNum || this.studentRate) {
                td1_right[0].style.transform = "translateX(-100px)"
            } else {

            }
        },
        logoTright() {
            var td1_right = document.getElementsByClassName("td1_right")
            td1_right[0].style.transform = "translateX(0px)"
        },
        hidSpan() {
            if (adSpan.innerHTML == "") {
                adSpan.style.display = "none"
            }
        },
        getTeacherDetail(val) {
            axios.get(`https://public.rossoarts.com/api/getTeacher?id=${val}`).then((data) => {
                console.log(data.data.data);

                this.luSchool = data.data.data.school_case.slice(0,8)
                console.log(this.luSchool);
                this.tutorsData = data.data.data
                this.studentRate = data.data.data.success_rate
                this.studentNum = data.data.data.student_num
                if (data.data.data.category == "2") {
                    this.tutorName = "Prof." + this.tutorsData.name
                } else {
                    this.tutorName = this.tutorsData.name
                }

                var td1_right_lan_title2 = document.getElementsByClassName("td1_right_lan_title2")
                var td1_right_lan_title1 = document.getElementsByClassName("td1_right_lan_title1")
                if (this.studentRate) {
                    // console.log("jin");
                } else {
                    td1_right_lan_title2[0].style.display = "none"
                }
                if (this.studentNum) {
                    // console.log("jin");
                } else {
                    td1_right_lan_title1[0].style.display = "none"
                }

                this.$nextTick(() => {
                    this.hidSpan()
                })
            })
        }
    },
    mounted() {

    }
}
</script>